import { mutator, mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { onTimeFilterButtonClicked, onTimeCalloutDismiss } from '../actions/internalActions';
import {
    getStartOfWeek,
    getEndOfLastWeek,
    getStartOfLastWeek,
    getEndOfLastMonth,
    getStartOfLastMonth,
    getEndOfLastYear,
    getStartOfLastYear,
} from '../utils/dateRangeUtils';
import { startOfYear, startOfMonth, subDays, today } from 'owa-datetime';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { logUsage } from 'owa-analytics';

mutator(onTimeFilterButtonClicked, () => {
    getStore().shouldShowTimeFilterCallout = !getStore().shouldShowTimeFilterCallout;
});

mutator(onTimeCalloutDismiss, () => {
    getStore().shouldShowTimeFilterCallout = false;
});

export const setDateRangeFromDropdownOption = mutatorAction(
    'setDateRangeFromDropdownOption',
    (item: IDropdownOption): void => {
        const mailSearchStore = getStore();
        const todayDate = today();
        const yesterday = subDays(todayDate, 1);
        const key = item.key;
        logUsage('SearchFilter_DateRangeSelected', { key });
        switch (key) {
            case 'today':
                mailSearchStore.fromDate = todayDate;
                mailSearchStore.toDate = todayDate;
                break;
            case 'yesterday':
                mailSearchStore.fromDate = yesterday;
                mailSearchStore.toDate = yesterday;
                break;
            case 'thisweek':
                mailSearchStore.fromDate = getStartOfWeek(todayDate);
                mailSearchStore.toDate = todayDate;
                break;
            case 'lastweek':
                mailSearchStore.fromDate = getStartOfLastWeek(todayDate);
                mailSearchStore.toDate = getEndOfLastWeek(todayDate);
                break;
            case 'thismonth':
                mailSearchStore.fromDate = startOfMonth(todayDate);
                mailSearchStore.toDate = todayDate;
                break;
            case 'lastmonth':
                mailSearchStore.fromDate = getStartOfLastMonth(todayDate);
                mailSearchStore.toDate = getEndOfLastMonth(todayDate);
                break;
            case 'thisyear':
                mailSearchStore.fromDate = startOfYear(todayDate);
                mailSearchStore.toDate = todayDate;
                break;
            case 'lastyear':
                mailSearchStore.fromDate = getStartOfLastYear(todayDate);
                mailSearchStore.toDate = getEndOfLastYear(todayDate);
                break;
            case 'anydate':
            default:
                mailSearchStore.fromDate = null;
                mailSearchStore.toDate = null;
                break;
        }
    }
);
